import { useToast } from "duck";
import { useUpdateOrganizationMutation } from "requests";
import { FormValues } from "./types";

export const useIntegrateVetspire = (_id: number) => {
  const [update] = useUpdateOrganizationMutation({ ignoreResults: true });
  const toast = useToast({
    status: "success",
    description: "Account is linked successfully."
  });

  return (formValues: FormValues) =>
    update({
      variables: {
        input: {
          _id,
          vetspireApiKey: formValues.vetspireApiKey
        }
      }
    }).then(() => toast());
};
